import React from 'react';
import AuthPage from './AuthPage';

const SignUpPage = () => <AuthPage mode="signup" />;

export default SignUpPage;
